import { render, staticRenderFns } from "./SSDialog.vue?vue&type=template&id=7cb65f35&scoped=true&"
import script from "./SSDialog.vue?vue&type=script&lang=js&"
export * from "./SSDialog.vue?vue&type=script&lang=js&"
import style0 from "./SSDialog.vue?vue&type=style&index=0&id=7cb65f35&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb65f35",
  null
  
)

export default component.exports